import { render } from "./ImageSlides.vue?vue&type=template&id=2545d5e0&scoped=true&ts=true"
import script from "./ImageSlides.vue?vue&type=script&lang=ts"
export * from "./ImageSlides.vue?vue&type=script&lang=ts"

import "./ImageSlides.vue?vue&type=style&index=0&id=2545d5e0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2545d5e0"]])

export default __exports__